import { useContext } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { AppCtx } from '../AppCtx';

const Timer = function (callback, delay) {
  let timerId = delay;
  let start = delay;
  let remaining = delay;

  this.pause = () => {
    clearTimeout(timerId);
    remaining -= Date.now() - start;
  };

  this.resume = () => {
    start = Date.now();
    clearTimeout(timerId);
    timerId = setTimeout(callback, remaining);
  };

  this.resume();
};

export function useAlerts() {
  const { alerts, setAlerts } = useContext(AppCtx);

  const deleteAlert = (alertId) => {
    setAlerts((prevAlerts) => {
      const newAlerts = prevAlerts.filter((alert) => { return alert.id !== alertId; });
      return newAlerts;
    });
  };

  const hideAlert = (alertId) => {
    setAlerts((prevAlerts) => {
      const index = prevAlerts.findIndex((alert) => { return alert.id === alertId; });
      if (-1 === index) { return prevAlerts; }

      const newAlerts = [ ...prevAlerts ];
      newAlerts[index].show = false;
      return newAlerts;
    });

    // clear the memory once the alert gets hidden
    setTimeout(() => { return deleteAlert(alertId); }, 1000);
  };

  const createAlert = ({ type = 'info', message }) => {
    const alertId = uuidv4();

    const timer = new Timer((() => {
      hideAlert(alertId);
    }), 6000);

    const alert = {
      id: alertId,
      message,
      type, // 'error' | 'info' | 'success' | 'warning'
      show: true,
      timer,
      onClose: () => { return hideAlert(alertId); },
    };

    setAlerts((prevAlerts) => { return [ alert, ...prevAlerts ]; });
  };

  const autoHidePause = () => {
    setAlerts((prevAlerts) => {
      prevAlerts.forEach((alert) => {
        alert.timer.pause();
      });
      return prevAlerts;
    });
  };

  const autoHideResume = () => {
    setAlerts((prevAlerts) => {
      prevAlerts.forEach((alert) => {
        alert.timer.resume();
      });
      return prevAlerts;
    });
  };

  const alertSuccess = (message) => { return createAlert({ type: 'success', message }); };
  const alertError = (message) => { return createAlert({ type: 'error', message }); };
  const alertInfo = (message) => { return createAlert({ type: 'info', message }); };
  const alertWarning = (message) => { return createAlert({ type: 'warning', message }); };

  return {
    alerts,
    alertSuccess,
    alertError,
    alertInfo,
    alertWarning,
    alertsAutoHidePause: autoHidePause,
    alertsAutoHideResume: autoHideResume,
  };
}
